import { useTranslation } from "react-i18next";
import { ShieldCheck, Activity, Bug, Zap, ShieldX } from "lucide-react";

const SolutionDescription = ({ solutionKey }) => {
  const { t } = useTranslation();

  const renderImage = () => {
    switch (solutionKey) {
      case "voiceapi":
        return <img src="/Voice Call API.png" alt="Voice Call API" className="w-full h-auto" />;
      case "aicounting":
        return <img src="/AI People Counting.png" alt="AI People Counting" className="w-full h-auto" />;
      case "networking":
        return (
          <div className="flex flex-col gap-1">
            <img src="/Networking-Left.png" alt="Networking Left" className="w-3/4 h-auto mx-auto" />
            <img src="/Networking-Right.png" alt="Networking Right" className="w-3/4 h-auto mx-auto" />
          </div>
        );
      case "skydial":
        return <img src="/img-skydial-hero.svg" alt="Skydial" className="w-1/2 sm:w-2/3 mx-auto h-auto" />;
      case "vms":
        return <img src="/vms.png" alt="Visitor Management System" className="w-full h-auto" />;
      case "soc":
        return (
          <div className="flex flex-col gap-4">
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-xl p-5 text-center">
                <Activity className="w-10 h-10 text-red-600 mx-auto mb-2" />
                <p className="text-sm font-semibold text-gray-800">{t("solutions.soc.cardMonitoring")}</p>
              </div>
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-5 text-center">
                <ShieldCheck className="w-10 h-10 text-blue-600 mx-auto mb-2" />
                <p className="text-sm font-semibold text-gray-800">{t("solutions.soc.cardThreat")}</p>
              </div>
            </div>
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-5">
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">{t("solutions.soc.cardPlatform")}</p>
              <p className="text-sm text-gray-600">{t("solutions.soc.cardPlatformDesc")}</p>
            </div>
          </div>
        );
      case "vapt":
        return (
          <div className="flex flex-col gap-4">
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl p-5 text-center">
                <Bug className="w-10 h-10 text-amber-600 mx-auto mb-2" />
                <p className="text-sm font-semibold text-gray-800">{t("solutions.vapt.cardEffort")}</p>
              </div>
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-5 text-center">
                <Zap className="w-10 h-10 text-blue-600 mx-auto mb-2" />
                <p className="text-sm font-semibold text-gray-800">{t("solutions.vapt.cardHours")}</p>
              </div>
            </div>
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-5">
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">{t("solutions.vapt.cardPlatform")}</p>
              <p className="text-sm text-gray-600">{t("solutions.vapt.cardPlatformDesc")}</p>
            </div>
          </div>
        );
      case "firstprotect":
        return (
          <div className="flex flex-col gap-4">
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-xl p-5 text-center">
                <ShieldX className="w-10 h-10 text-indigo-600 mx-auto mb-2" />
                <p className="text-sm font-semibold text-gray-800">{t("solutions.firstprotect.cardPrevention")}</p>
              </div>
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-5 text-center">
                <Zap className="w-10 h-10 text-blue-600 mx-auto mb-2" />
                <p className="text-sm font-semibold text-gray-800">{t("solutions.firstprotect.cardLatency")}</p>
              </div>
            </div>
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-5">
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">{t("solutions.firstprotect.cardPlatform")}</p>
              <p className="text-sm text-gray-600">{t("solutions.firstprotect.cardPlatformDesc")}</p>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const hasImage = ["skydial", "voiceapi", "aicounting", "networking", "vms", "soc", "vapt", "firstprotect"].includes(solutionKey);

  return (
    <section className="py-8 px-6 md:px-16 sm:px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-1 gap-12 items-center my-8">
          {/* Left - Image */}
          {hasImage && (
            <div className={`rounded-2xl overflow-hidden ${solutionKey === "skydial" ? "flex justify-center" : ""}`}>
              {renderImage()}
            </div>
          )}

          {/* Right - Description */}
          <div className={hasImage ? "" : "md:col-span-2"}>
            <p className="text-lg md:text-base sm:text-sm text-gray-600 leading-relaxed">
              {t(`solutions.${solutionKey}.description`)}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionDescription;
